module.exports = __webpack_public_path__ + "images/emoji/airplane.dfe3d356a79c1e7df2eb.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/airplane.png
// module id = R7qY
// module chunks = 1